import {
  IUserMenuItem,
  journalistMenuItems,
  managerMenuItems,
} from '../usersMenu';
import { IUser } from '../../../../api/base/Auth/types';
import { useMemo } from 'react';
import { USER_ROLES } from '../../../../utils/types/user';
import { matchPath } from 'react-router-dom';

type TItemClick = (path: string) => void;

export type PUserMenuItem = {
  item: IUserMenuItem;
  isActive?: boolean;
  onClick?: TItemClick;
};

export type PMenuItems = {
  user: IUser;
  className?: any;
  currentPath: string;
};

export const useCurrentUserMenu = (props: any) => {
  const { user } = props;
  const currentList = useMemo(() => {
    switch (user?.role) {
      case USER_ROLES.JOURNALIST:
        return journalistMenuItems;
      case USER_ROLES.EXPERT:
        return managerMenuItems;
      default:
        return journalistMenuItems;
    }
  }, [user]);
  return { currentList };
};

export const checkIsMenuItemActive = ({
  currentPath,
  itemPath,
  basePath,
}: any): boolean => {
  const match = matchPath(currentPath, {
    path: itemPath,
    exact: false,
    strict: false,
  });
  return basePath ? currentPath.startsWith(basePath) : match;
};
